"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_ejs_1 = require("./form.ejs");
exports.default = { form: form_ejs_1.default };



//////////////////
// WEBPACK FOOTER
// ./~/@formio/semantic/lib/templates/semantic/file/index.js
// module id = 1658
// module chunks = 0